import { DebugNotificationProps } from "@omni/types/components/utils/debugNotification.props";
import { Alert } from "@omni/ui/components/Alert/alert.component";
import { Button } from "@omni/ui/components/Button/button.component";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

const DebugNotification = ({
    message,
    url,
    type,
    correlationId,
    isDebug
}: DebugNotificationProps) => {
    const { t } = useGranite();

    const copyUrl = () => {
        url && navigator.clipboard.writeText(url);
    };

    const copyCorrelationId = () => {
        correlationId && navigator.clipboard.writeText(correlationId);
    };

    return isDebug ? (
        <Alert
            color={type}
            closeAriaLabel={t("general.alert.close")}
        >
            {message}
            <Button
                color="link"
                onClick={copyCorrelationId}
            >
                <i className="las la-copy pr-2"></i>
                {"Copy C-ID"}
            </Button>
            {url && (
                <Button
                    color="link"
                    onClick={copyUrl}
                >
                    <i className="las la-copy pr-2"></i>
                    {"Copy Url"}
                </Button>
            )}
        </Alert>
    ) : (
        <div
            data-ssr-error
            dangerouslySetInnerHTML={{ __html: `<!-- ${correlationId} -->` }}
        ></div>
    );
};

export { DebugNotification };
